let dropdownLoaded = false

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    if (!dropdownLoaded) {
      window.BAO.sectionRenderer
        .fetch('header', `${window.Shopify.routes.root}?view=dropdown`)
        .then(res => {
          dropdownLoaded = true

          const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
          const myself = newDOM.querySelector(this.localName)

          this.outerHTML = myself.outerHTML
        })
        .catch(() => {})
    }

    this.setupListeners()
  }

  setupListeners () {
    if (this.els?.item?.exists) {
      this.els.item.elements.forEach(itemEl => {
        itemEl.addEventListener('focusin', this.onFocusIn.bind(this))
        itemEl.addEventListener('focusout', this.onFocusOut.bind(this))
      })
    }

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(closeEl => {
        closeEl.addEventListener('click', this.onClose.bind(this))
      })
    }

    if (this.externalEls?.close?.exists) {
      this.externalEls.close.elements.forEach(closeEl => {
        closeEl.addEventListener('click', this.onClose.bind(this))
        closeEl.addEventListener('mouseenter', this.onClose.bind(this))
      })
    }

    if (this.els?.['banner-link']?.exists) {
      this.addEventListener('click', this.onMouseClick.bind(this))
      this.addEventListener('keydown', this.onKeydown.bind(this))
    }
  }

  /**
   * @param {ClickEvent} e
   *
   * @returns {void}
   */
  onMouseClick (e) {
    const bannerLinkEl = e.target.closest(this.els['banner-link'].selector)

    if (!bannerLinkEl) return

    const targetEl = bannerLinkEl.closest(this.els.item.selector)

    if (!targetEl) return

    const alreadyOpen = targetEl.getAttribute('aria-expanded') === 'true'

    if (alreadyOpen) {
      this.onClose()
    } else {
      this.onOpen(targetEl)
    }
  }

  /**
   * Escape closes the open dropdown and returns focus to its trigger,
   * instead of forcing keyboard users to tab through every item inside it.
   *
   * @param {KeyboardEvent} e
   *
   * @returns {void}
   */
  onKeydown (e) {
    if (e.key !== 'Escape') return

    const openItemEl = this.els.item.elements.find(
      itemEl => itemEl.getAttribute('aria-expanded') === 'true',
    )

    if (!openItemEl) return

    const triggerEl = openItemEl.querySelector(this.els['banner-link'].selector)

    this.onClose()

    if (!triggerEl) return

    // Focusing the trigger below would otherwise immediately re-open it via
    // onFocusIn, since the trigger lives inside the item being closed.
    openItemEl._suppressNextFocusIn = true
    triggerEl.focus()
  }

  onOpen (targetEl) {
    document.body.classList.add(this.config.classes.menuActiveClass)

    if (this.els?.item?.exists) {
      this.els.item.elements.forEach(itemEl => {
        this.setExpanded(itemEl, itemEl === targetEl)
      })
    }
  }

  /**
   * @param {FocusInEvent} e
   *
   * @returns {void}
   */
  onFocusIn (e) {
    const itemEl = e.currentTarget

    if (itemEl._suppressNextFocusIn) {
      itemEl._suppressNextFocusIn = false

      return
    }

    document.body.classList.add(this.config.classes.menuActiveClass)

    if (this.els?.item?.exists) {
      this.els.item.elements.forEach(el => {
        this.setExpanded(el, el === itemEl)
      })
    }
  }

  /**
   * Closes the item once focus moves outside of it entirely, so tabbing
   * past the dropdown doesn't leave it visually stuck open.
   *
   * @param {FocusOutEvent} e
   *
   * @returns {void}
   */
  onFocusOut (e) {
    const itemEl = e.currentTarget

    if (e.relatedTarget && itemEl.contains(e.relatedTarget)) return

    this.setExpanded(itemEl, false)

    const anyItemStillOpen = this.els?.item?.elements?.some(
      el => el.getAttribute('aria-expanded') === 'true',
    )

    if (!anyItemStillOpen) {
      window.setTimeout(() => {
        document.body.classList.remove(this.config.classes.menuActiveClass)
      }, 200)
    }
  }

  onClose () {
    window.setTimeout(() => {
      document.body.classList.remove(this.config.classes.menuActiveClass)
    }, 200)

    if (this.els?.item?.exists) {
      this.els.item.elements.forEach(itemEl => {
        this.setExpanded(itemEl, false)
      })
    }
  }

  /**
   * @param {HTMLElement} itemEl
   * @param {Boolean} isExpanded
   *
   * @returns {void}
   */
  setExpanded (itemEl, isExpanded) {
    itemEl.setAttribute('aria-expanded', isExpanded)

    const triggerEl = itemEl.querySelector(this.els['banner-link']?.selector)

    triggerEl?.setAttribute('aria-expanded', isExpanded)
  }

  get config () {
    return {
      classes: {
        menuActiveClass: 'lyt-Site-desktopMenuOpen',
      },
    }
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
